import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAdminHeaderTitle } from '../../utils/pageTitles';
import logo from '../../Assets/logo.jpg';
import { FiSearch, FiUser, FiLogOut, FiMenu, FiX, FiLoader } from 'react-icons/fi';
import './AdminLayout.css';
import { API_URL } from '../../Api/api';
import { clearTokens } from '../../Api/authToken';
import NotificationBell from '../../Components/NotificationBell';
import AdminThemeMenu from './AdminThemeMenu';
import ChatNotify from './ChatNotify';

const Header = ({ user, onMenuToggle, basePath = '/admin', chatAccess = false, userChatAccess = true, prefsScope = 'admin' }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pageTitle = getAdminHeaderTitle(pathname, basePath);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const searchRef = useRef(null);

  // Debounced search (300ms)
  useEffect(() => {
    if (!searchTerm.trim()) {
      setIsSearching(false);
      return;
    }
    setIsSearching(true);
    const timer = setTimeout(() => {
      navigate(`${basePath}/properties?search=${encodeURIComponent(searchTerm.trim())}`);
      setIsSearching(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, navigate, basePath]);

  const handleLogout = () => {
    if (basePath === '/partner') {
      clearTokens('partner');
      navigate('/partner/login');
    } else {
      clearTokens('admin');
      navigate('/admin/login');
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
    setIsSearching(false);
    searchRef.current?.focus();
  };

  return (
    <header className="admin-header">
      <div className="header-left">
        <button className="hamburger-btn" onClick={onMenuToggle} title="Toggle menu">
          <FiMenu />
        </button>
        <img src={logo} alt="Properties Infinite" className="admin-header-logo" />
        <span className="admin-header-page-title">{pageTitle}</span>
        <div className="header-search-box">
          <FiSearch className="header-search-icon" />
          <input
            ref={searchRef}
            type="text"
            placeholder="Search listings..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="header-search-input"
          />
          {isSearching && <FiLoader className="header-search-spinner" />}
          {searchTerm && !isSearching && (
            <button className="header-search-clear" onClick={clearSearch}>
              <FiX />
            </button>
          )}
        </div>
      </div>

      <div className="header-right">
        {((basePath === '/admin' && userChatAccess) || (basePath !== '/admin' && chatAccess)) && (
          <ChatNotify
            basePath={basePath}
            notificationsUrl={basePath === '/partner' ? `${API_URL}/admin/chat/mine/notifications` : ''}
          />
        )}
        <NotificationBell />
        <AdminThemeMenu scope={prefsScope} />

        <div className="user-profile">
          <div className="user-info">
            <p className="user-name">{user?.admin_name || user?.name || 'Admin'}</p>
            <p className="user-role">{user?.role === 'partner' ? 'Partner' : user?.role === 'sub_admin' ? 'Sub Admin' : 'Admin'}</p>
          </div>
          <div className="user-avatar">
            <FiUser />
          </div>
        </div>

        <button className="logout-header-btn" onClick={handleLogout} title="Logout">
          <FiLogOut />
        </button>
      </div>
    </header>
  );
};

export default Header;
